module.exports = __webpack_public_path__ + "static/img/back.a4b4c167.png";